import { Alert } from 'antd';

import type { NCustomAlert } from '@app/components/CustomAlert/CustomAlert.types';

export const CustomAlert: NCustomAlert.Main = ({
  errorType,
  serverError,
  setServerError,
}) => {
  return (
    <div className="alert-container">
      <Alert
        className="alert"
        description={serverError}
        closable
        onClose={() => setServerError && setServerError('')}
        type={errorType}
        showIcon
      />
    </div>
  );
};
